<template>
  <generic-update :model="model">
    <template v-slot:form="{ error, fetch, item, loading, submit }">
      <band-form
        :with-data="item"
        :error="error"
        :loading="loading"
        @submit="submit"
        @reset="fetch"
      />
    </template>
  </generic-update>
</template>

<script>
import BandForm from "./Form"
import model from "./model"

export default {
  components: { BandForm },
  data() {
    return {
      model,
      localData: {},
    }
  },
}
</script>
